import ForgotPasswordForm from '@/modules/auth/forgot-password-form'

const ForgotPasswordPage = () => {
  return (
    <div className='flex h-full w-full flex-col bg-white'>
      <main className='flex flex-1 items-center justify-center p-4'>
        <div className='mx-auto w-full max-w-md'>
          <div className='mb-8 text-center'>
            <h1 className='mb-2 text-2xl font-bold text-gray-700'>
              Forgot Password
            </h1>
            <p className='text-gray-600'>
              Enter your email to reset your password.
            </p>
          </div>
          <ForgotPasswordForm />
        </div>
      </main>
    </div>
  )
}

export default ForgotPasswordPage